/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormState, FormStateBuilder, getDialogInitData, MaskedTypes } from '@gh/common-shared';
import { DialogInput, NotificationService, WaitingService } from '@gh/core-ui';
import { AuthNumberBusinessService } from '../../resources/auth-number-business.service';
import { AuthNumber } from '../../resources/auth-number.model';

export interface AuthNumberRequestConfig {
  entryPoint: string;
}

@Component({
  standalone: false,
  selector: 'gh-auth-number-request-dialog',
  templateUrl: 'auth-number-request-dialog.component.html',
  styleUrls: ['auth-number-request-dialog.component.scss'],
})
export class AuthNumberRequestDialogComponent implements DialogInput<AuthNumberRequestConfig>, OnInit {
  input: AuthNumberRequestConfig;
  form: FormState<AuthNumber>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private formStateBuilder: FormStateBuilder,
    private notifications: NotificationService,
    private business: AuthNumberBusinessService,
    public dialogRef: MatDialogRef<AuthNumberRequestDialogComponent>,
    private waitings: WaitingService,
  ) {

  }

  ngOnInit(): void {
    const { request } = getDialogInitData(this.dialogData);

    this.form = this.formStateBuilder.buildPlain({
      value: request,
      children: {
        sourceNumber: void 0,
        token: void 0,
        authNumber: {
          required: true,
          type: MaskedTypes.AuthNumber,
        },
      },
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.business.validate(this.form.submitValue).pipe(
      this.waitings.operator())
      .subscribe(
        (authNumberRequest) => this.dialogRef.close(authNumberRequest.authNumberToken),
        (errors) => this.notifications.processAll(errors),
      );

  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
